import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PermissionsRoleTemplatesListFragment } from 'generated/resources/graphql'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import TemplateCard from './TemplateCard/templateCard'
import VerbsList from './VerbsList'

interface Props {
  templates: PermissionsRoleTemplatesListFragment[]
  onSelectedTemplateChange: (id: string | undefined) => void
}

function RoleTemplatesList({ templates, onSelectedTemplateChange }: Props) {
  const displayedTemplates = templates
    .filter((template) => template.verbs.length > 0)
    .sort((a, b) => a.name.localeCompare(b.name))

  const [selectedTemplateId, setSelectedTemplateId] = useState(displayedTemplates[0]?.id)
  useUnsafeEffect(() => {
    onSelectedTemplateChange(selectedTemplateId)
  }, [onSelectedTemplateChange, selectedTemplateId])

  const selectedTemplate = displayedTemplates.find((template) => template.id === selectedTemplateId)
  const verbs = selectedTemplate?.verbs || []

  return (
    <Box flexDirection="row" gap="s32" overflowX="auto">
      <Box width="s400" gap="s16" paddingX="s16" overflowY="auto">
        {displayedTemplates.map((template) => (
          <TemplateCard
            key={template.id}
            name={template.name}
            description={template.description}
            selected={template.id === selectedTemplateId}
            onClick={() => setSelectedTemplateId(template.id)}
          />
        ))}
      </Box>
      <Box borderRadius={{ all: 'abs008' }} paddingRight="s12" gap="s24" overflowY="auto">
        <Text.Header1>{selectedTemplate?.name}</Text.Header1>
        <VerbsList verbs={verbs} />
      </Box>
    </Box>
  )
}

export default RoleTemplatesList
